import React from 'react'

export default function Separator() {
  return (
    <div style={{ width: '100%', height: 1, background: 'var(--stroke)' }} />
  )
}
